import React from 'react';
import ReactDOM from 'react-dom';
import { ModalOverlay, ModalContainer, ModalCloseButton } from './ModalStyle';
import CloseIcon from '@mui/icons-material/Close';

const modalRoot = typeof document !== 'undefined'
    ? document.getElementById('modal-root')
    : null;

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen || !modalRoot) return null;

    return ReactDOM.createPortal(
        <>
            <ModalOverlay onClick={onClose} />
            <ModalContainer
                role="dialog"
                aria-modal="true"
            >
                <ModalCloseButton onClick={onClose} aria-label="Cerrar modal">
                    <CloseIcon fontSize="small" />
                </ModalCloseButton>
                {children}
            </ModalContainer>
        </>,
        modalRoot
    );
};

export default Modal;

